import ActionType from '../../actions/home/ActionType';


const initialState={
    news_data:[],
    tech_finance_data:[],
    partner_data:[],
    carousel_data:[],
}

const homeReducer=(state=initialState,action={})=>{
    switch(action.type){
        case ActionType.FETCH_HOME_NEWS:
            return Object.assign({},state,{
                news_data:action.data
            })
        case ActionType.FETCH_HOME_TECH_FINANCE:
            return Object.assign({},state,{
                tech_finance_data:action.data,
            })
        case ActionType.FETCH_PARTNERS:
            return Object.assign({},state,{
                partner_data:action.data,
            });
        case ActionType.FETCH_CAROUSEL_DATA:
            return Object.assign({},state,{
                carousel_data:action.data
            })
        default:
            return state;
    }
}

export default homeReducer;